<template>
  <!-- 第一层嵌套 -->
  <div @click.stop="!noClick && toggleChildren()"
       v-if="is_del">
    <div class="one"
         :class="{ resetOne: level > 0 }">
      <!--  -->
      <div class="one_content">
        <div class="title"
             :style="{ paddingLeft: paddingLeft }">
          <v-icon :style="{
              visibility:
                noClick || !obj.sub || obj.sub.length <= 0
                  ? 'hidden'
                  : 'visible',
            }"
                  class="icon mr-2"
                  :class="{ transformIcon: showChildren }">arrow_drop_down</v-icon>
          <div class="title_name">{{ INT(obj.names) }}</div>
        </div>
        <!-- :style="{ visibility: obj.sub && obj.sub.length > 0 ? 'hidden' : 'visible'}" -->
        <div class="icons"
             :style="{ visibility: obj.type == 3 ? 'visible' : 'hidden' }">
          <mrc_ess_showClientType :iconList="obj.clientType"></mrc_ess_showClientType>
        </div>
        <div class="func">{{ obj.shortcode }}</div>
        <div class="is_used">{{ obj.status_uuid }}</div>
        <div class="action">
          <menu-list :list="list"
                     v-if="obj.type != 4"
                     v-btnAuth="
              obj.type == 2
                ? ['edit-moduless', 'delete-moduless']
                : obj.type == 3
                ? ['edit-function', 'delete-function']
                : obj.type == 4
                ? ['edit-button', 'delete-button']
                : obj.type == 1
                ? ['edit-product', 'view-product']
                : false
            "
                     @handleClick="handleClick">
            <template v-slot:showAction>
              <v-icon>mdi-dots-vertical</v-icon>
            </template>
          </menu-list>
        </div>
      </div>
      <div v-if="obj.sub && obj.sub.length > 0 && showChildren">
        <one v-for="item in obj.sub"
             :key="item.uuid"
             :obj="item"
             :level="level + 1"
             @delData="delData"></one>
      </div>
    </div>
  </div>
</template>

<script>
import { get_del, get_func_del } from '@/service/api/func_module'

export default {
  name: 'one',
  components: {},
  props: {
    obj: {
      type: Object,
    },
    level: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      showChildren: false,
      is_del: true,
      noClick: false,
    }
  },
  created () { },
  mounted () { },
  methods: {
    toggleChildren () {
      this.showChildren = !this.showChildren
    },
    handleClick ({ item }) {
      if (item.type == 'view') {
        let pgae_name = ''
        if (this.obj.type == 2) {
          pgae_name = 'module_detail'
        } else if (this.obj.type == 3) {
          pgae_name = 'func_detail'
        } else if (this.obj.type == 4) {
          pgae_name = 'func_detail'
        }
        this.$store.commit('set_subPage_name', this.obj.names)
        this.$store.commit('set_uuid', this.obj.uuid)
        this.$store.commit('set_iconstatus', true)
        this.$router.push({
          name: pgae_name,
          params: {
            name: this.obj.names,
            uuid: this.obj.uuid,
          },
        })
      }
      // 编辑
      if (item.type == 'edit') {
        this.edit(this.obj.names, this.obj.uuid, this.obj.sub, this.obj.type)
      }
      if (item.type == 'del') {
        this.del(this.obj.uuid, this.obj.type)
      }
    },
    edit (name, uuid, hasChild, type) {
      // console.log(type)
      let pgae_name = ''
      if (type == 2) {
        pgae_name = 'module_detail'
      } else if (type == 3) {
        pgae_name = 'func_detail'
      } else if (type == 4) {
        pgae_name = 'func_detail'
      }
      this.$store.commit('set_subPage_name', name)
      this.$store.commit('set_uuid', uuid)
      this.$store.commit('set_iconstatus', false)
      this.$router.push({
        name: pgae_name,
        params: {
          name,
          uuid,
        },
      })
    },
    del (uuid, type) {
      this.$myConfirm({
        title: this.$t('message_tips'),
        content: this.$t('message_Confirm_the_deletion'),
      })
        .then(async () => {
          // console.log(123)
          if (type == 2) {
            // 删除模块
            const del = await get_del({ uuid })
            if (del.code == 200) {
              this.$Message({
                text: this.$t('message_The_deletion_was_successful'),
                color: 'rgba(0,0,0,0.78)',
              })
              this.is_del = false
              this.$emit('delData', uuid)
            }
          }
          if (type == 3 || type == 4) {
            // 删除功能
            const del = await get_func_del({ uuid })
            if (del.code == 200) {
              this.$Message({
                text: this.$t('message_The_deletion_was_successful'),
                color: 'rgba(0,0,0,0.78)',
              })
              this.is_del = false
              this.$emit('delData', uuid)
            }
          }
        })
        .catch(() => {
          // console.log(456)
        })
    },
    delData (uuid) {
      this.$emit('delData', uuid)
      // this.noClick = true
    },
  },
  computed: {
    paddingLeft () {
      return this.level * 15 + 'px'
    },
    list () {
      return [
        {
          type: 'view',
          name: this.$t('label_View'),
          show:
            this.obj.type == 2
              ? this.hasBtn('view-module')
              : this.obj.type == 3
                ? this.hasBtn('view-function')
                : this.obj.type == 4
                  ? this.hasBtn('view-button')
                  : this.obj.type == 1
                    ? this.hasBtn('view-product')
                    : false,
        },
        {
          type: 'edit',
          name: this.$t('label_Edit'),
          show:
            this.obj.type == 2
              ? this.hasBtn('edit-module')
              : this.obj.type == 3
                ? this.hasBtn('edit-function')
                : this.obj.type == 4
                  ? this.hasBtn('edit-button')
                  : this.obj.type == 1
                    ? this.hasBtn('edit-product')
                    : false,
        },
        {
          type: 'del',
          name: this.$t('label_delete'),
          show:
            this.obj.type == 2
              ? this.hasBtn('delete-module')
              : this.obj.type == 3
                ? this.hasBtn('delete-function')
                : this.obj.type == 4
                  ? this.hasBtn('delete-button')
                  : false,
        },
      ]
    },
  },
  watch: {},
}
</script>

<style scoped>
.one {
  width: 100%;
  border: 1px solid #dedede;
  /* border-top: none; */
  /* border-bottom: none; */
  border-radius: 8px;
  /* margin: 10px 0; */
}
.one_content {
  width: 100%;
  height: 60px;
  /* border-bottom: 1px solid #dedede; */
  display: flex;
  font-size: 17px;
  align-items: center;
  justify-content: space-between;
}
.resetOne {
  border: none;
  border-top: 1px solid #dedede;
  border-bottom: none;
  /* border-bottom: 1px solid #dedede; */
  border-radius: 0px;
  margin: 0;
}
.one_content .title {
  display: flex;
  align-items: center;
  margin-left: 10px;
  width: 30%;
}
.one_content .title_name {
  font-size: 17px;
}
.one_content .action {
  width: 50px;
}
.icon {
  transform: rotate(-90deg);
}
.transformIcon {
  transform: rotate(0deg);
}
</style>
